import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { birdLogsService } from '../services/apiServices';
import { BirdLog, PaginatedResponse } from '../types';

// Query Keys
export const queryKeys = {
  birdLogs: (params?: any) => ['birdLogs', params] as const,
  birdLog: (id: number) => ['birdLog', id] as const,
};

// Queries
export const useBirdLogs = (params?: any) => {
  return useQuery<PaginatedResponse<BirdLog>>({
    queryKey: queryKeys.birdLogs(params),
    queryFn: () => birdLogsService.getAll(params),
    placeholderData: (previousData) => previousData,
  });
};

export const useBirdLog = (id: number) => {
  return useQuery<BirdLog>({
    queryKey: queryKeys.birdLog(id),
    queryFn: () => birdLogsService.getById(id),
    enabled: !!id,
  });
};

// Mutations
export const useCreateBirdLog = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: Partial<BirdLog>) => birdLogsService.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['birdLogs'] });
    },
  });
};

export const useDeleteBirdLog = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => birdLogsService.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['birdLogs'] });
    },
  });
};
